import React, { useState } from 'react';
import { CustomTimePickerTime } from '../../../../BaseModule/Components/TimePickerCustom/TimePickerCustom';
import CaseTermPicker from '../CaseTermPicker/CaseTermPicker';
import Button from '../../../../BaseModule/Components/Button';
import FullPageLoading from '../../../../BaseModule/Components/FullPageLoading';

interface Props {
	workplaceId: string;
	workplaceMemberId: string;
	workplaceCaseTypeId: string;
	onSubmit?: (data: CustomTimePickerTime) => void;
	onSelect?: (data: CustomTimePickerTime) => void;
	minDate?: string;
	maxDate?: string;
	preselectedDateTime?: string;
}

const DateSelection: React.FC<Props> = ({
	workplaceId,
	workplaceMemberId,
	workplaceCaseTypeId,
	minDate,
	maxDate,
	preselectedDateTime,
	onSubmit,
	onSelect,
}) => {
	const [selectedTime, setSelectedTime] = useState<
		CustomTimePickerTime | undefined
	>(undefined);
	const [isLoading, setIslLoading] = useState(false);

	const handleSelect = (date: CustomTimePickerTime | undefined) => {
		setSelectedTime(date);
		if (date) {
			onSelect?.(date);
		}
	};

	const handleSubmit = (date: CustomTimePickerTime) => {
		setIslLoading(true);
		onSubmit?.(date);
	};

	return (
		<>
			<CaseTermPicker
				workplaceId={workplaceId}
				workplaceMemberId={workplaceMemberId}
				workplaceCaseTypeId={workplaceCaseTypeId}
				onSelect={handleSelect}
				minDate={minDate}
				maxDate={maxDate}
				preselectedDateTime={preselectedDateTime}
			/>
			{selectedTime && onSubmit && (
				<div className='row mt-5'>
					<div className='col-lg-6 col-12 offset-lg-3 text-center'>
						<Button
							text='component.createCaseDateSelect.submitAndContinue'
							dataId='wizardConfirmButton'
							firstUpper
							onClick={() => handleSubmit(selectedTime)}
						/>
					</div>
				</div>
			)}
			{isLoading && <FullPageLoading />}
		</>
	);
};

export default DateSelection;
